window.lucybot.formatDatetime = function(date) {
  return date.getTime() / 1000;
}



// WEBPACK FOOTER //
// ../../../../../root/api-docs/assets/js/misc.js